import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import Footer from '../components/footer';

function App() {

	const userID = sessionStorage.getItem("TRCUserId");
	const userEmail = sessionStorage.getItem("TRCUserEmail");
	const userName = sessionStorage.getItem("TRCUserName");
	const userPosition = sessionStorage.getItem("TRCUserPosition");

    const [employeeData, setEmployeeData] = useState('');

    const newData = (e) => {
        const { name, value } = e.target;
        setEmployeeData((prevData) => ({
          ...prevData,
          [name]: value,
		  ['userId']: userID
        }));
    };

    const addEmployee = async (e) => {
		e.preventDefault();
		try {
			const response = await axios.post('https://api.trucoo.in/clients/add-client/', employeeData, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});

			if(response.data.status === 'success'){
				window.location = '/my-clients';
				
			}
	
			console.log(response.data);
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};

return(
<>
    <Header />
    <Sidebar />

    <div class="content-wrapper">
		<div class="container-full">
		
			<section class="content">
				<div class="box box-body">
					<form onSubmit={addEmployee}>
					<div class="row">
                       
						<div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-12">
                            <div class="box">
							    <div class="box-body">

								    <h4 class="box-title text-primary mb-0"><i class="ti-user me-15"></i> Personal Info</h4>
								    <hr class="my-15" />

								    <div class="row">
								        <div class="col-md-12">
									        <div class="form-group">
									            <label class="form-label">Full Name</label>
									            <input type="text" class="form-control" name="name" value={employeeData.name} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
								    </div>
								    <div class="row">
								        <div class="col-md-6">
									        <div class="form-group">
									            <label class="form-label">E-mail</label>
									            <input type="email" class="form-control" name="email" value={employeeData.email} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
								        <div class="col-md-6">
									        <div class="form-group">
									            <label class="form-label">Contact Number</label>
									            <input type="text" class="form-control" name="phone" value={employeeData.phone} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
								    </div>
                                    <div class="form-group">
								        <label class="form-label">Address</label>
								        <textarea rows="5" class="form-control" name="address" value={employeeData.address} onChange={(e)=>newData(e)} required></textarea>
								    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-12">
                            <div class="box">
                                <div class="box-body">
								    <h4 class="box-title text-primary mb-0"><i class="ti-save me-15"></i>Business Info</h4>
								    <hr class="my-15" />
                                    <div class="row">
								        <div class="col-md-6">
									        <div class="form-group">
									            <label class="form-label">Brand Name</label>
									            <input type="text" class="form-control" name="companyName" value={employeeData.companyName} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
								        <div class="col-md-6">
									        <div class="form-group">
                                            <label class="form-label">City</label>
											<input type="text" class="form-control" name="location" value={employeeData.location} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
								    </div>
								    <div class="row">
								        <div class="col-md-6">
									        <div class="form-group">
									            <label class="form-label">Company E-mail</label>
									            <input type="text" class="form-control" name="cEmail" value={employeeData.cEmail} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
								        <div class="col-md-6">
									        <div class="form-group">
									            <label class="form-label">Company Contact</label>
									            <input type="text" class="form-control" name="contact" value={employeeData.contact} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
										<div class="col-md-12">
									        <div class="form-group">
									            <label class="form-label">Company GST</label>
									            <input type="text" class="form-control" name="gst" value={employeeData.gst} onChange={(e)=>newData(e)} required />
									        </div>
								        </div>
								    </div>
								    <div class="form-group">
								        <label class="form-label">Company Address</label>
								        <textarea rows="5" class="form-control" name="about" value={employeeData.about} onChange={(e)=>newData(e)}></textarea>
								    </div>
							    </div>
							</div>
						</div>


                        <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                            <div class="box">
                                <div class="box-body">
							        <div class="box-footer" align="center">
								        <button type="button" class="btn btn-primary-light me-1" onClick={()=>{setEmployeeData('')}}><i class="ti-trash"></i> Cancel</button>
								        <button type="submit" class="btn btn-primary"><i class="ti-save-alt"></i> Save</button>
							        </div>  
						
					            </div>
						    </div>
						</div>
                     
					</div>
					</form>
				</div>
			</section>
		</div>
	</div>

	<Footer />
</>
);
}

export default App;